import React, { useState, useEffect } from "react";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../utils/storageUtil";

const DeliveryOptionContext = React.createContext();

const DeliveryOptionProvider = (props) => {
  const [selectedDeliveryOption, setSelectedDeliveryOption] = useState(
    getLocalStorage("deliveryOption") || {}
  );

  useEffect(() => {
    setLocalStorage("deliveryOption", selectedDeliveryOption);
  }, [selectedDeliveryOption]);

  function handleDeliverySelection(delOptObj) {
    const obj = {};

    if (!Object.keys(obj).length) {
      Object.assign(obj, delOptObj);
    }
    setSelectedDeliveryOption(obj);
  }

  function resetDeliverySelection() {
    setSelectedDeliveryOption({});
    removeLocalStorage("deliveryOption");
  }

  return (
    <DeliveryOptionContext.Provider
      value={{
        selectedDeliveryOption,
        handleDeliverySelection,
        resetDeliverySelection,
      }}
    >
      {props.children}
    </DeliveryOptionContext.Provider>
  );
};

export { DeliveryOptionProvider, DeliveryOptionContext };
